/**
 * Detailed Recipe Types
 * Type definitions for the new recipe format from WordPress REST API
 */
/**
 * Get available flame levels from a DetailedRecipe
 */
export function getAvailableFlames(recipe) {
    if (recipe.available_flames && recipe.available_flames.length > 0) {
        return recipe.available_flames;
    }
    // Fallback: check which flame-specific arrays exist
    const available = [];
    if (recipe.ingredients_1f && recipe.ingredients_1f.length > 0)
        available.push(1);
    if (recipe.ingredients_2f && recipe.ingredients_2f.length > 0)
        available.push(2);
    if (recipe.ingredients_3f && recipe.ingredients_3f.length > 0)
        available.push(3);
    return available.length > 0 ? available : [1]; // Default to flame 1 if none found
}
/**
 * Get ingredients for a specific flame level
 */
export function getIngredientsForFlame(recipe, flameLevel) {
    let ingredients;
    if (flameLevel === 1) {
        ingredients = recipe.ingredients_1f;
    }
    else if (flameLevel === 2) {
        ingredients = recipe.ingredients_2f;
    }
    else if (flameLevel === 3) {
        ingredients = recipe.ingredients_3f;
    }
    // Fallback: try other flame levels if requested one doesn't exist
    if (!ingredients || ingredients.length === 0) {
        if (recipe.ingredients_2f && recipe.ingredients_2f.length > 0) {
            ingredients = recipe.ingredients_2f;
        }
        else if (recipe.ingredients_1f && recipe.ingredients_1f.length > 0) {
            ingredients = recipe.ingredients_1f;
        }
        else if (recipe.ingredients_3f && recipe.ingredients_3f.length > 0) {
            ingredients = recipe.ingredients_3f;
        }
    }
    // Convert WpIngredient to DetailedRecipeIngredient
    return (ingredients || []).map((ing, index) => ({
        id: ing.id || `ing-${index}`,
        item: ing.item,
        ingredient: ing.ingredient,
        amount: ing.amount,
        unit: ing.unit,
        metric_g: ing.metric_g,
        metric_ml: ing.metric_ml,
        weight_g: ing.weight_g,
        note: ing.note,
    }));
}
/**
 * Get steps for a specific flame level
 */
export function getStepsForFlame(recipe, flameLevel) {
    let steps;
    if (flameLevel === 1) {
        steps = recipe.steps_1f;
    }
    else if (flameLevel === 2) {
        steps = recipe.steps_2f;
    }
    else if (flameLevel === 3) {
        steps = recipe.steps_3f;
    }
    // Fallback: try other flame levels if requested one doesn't exist
    if (!steps || steps.length === 0) {
        if (recipe.steps_2f && recipe.steps_2f.length > 0) {
            steps = recipe.steps_2f;
        }
        else if (recipe.steps_1f && recipe.steps_1f.length > 0) {
            steps = recipe.steps_1f;
        }
        else if (recipe.steps_3f && recipe.steps_3f.length > 0) {
            steps = recipe.steps_3f;
        }
    }
    // Convert WpStep to DetailedRecipeStep
    return (steps || []).map((step, index) => {
        var _a;
        const stepNumber = typeof step.id === 'number' ? step.id : step.stepNumber || index + 1;
        const instruction = step.instruction || step.method || '';
        // Type assertion to access additional properties from API
        const apiStep = step;
        return {
            id: ((_a = step.id) === null || _a === void 0 ? void 0 : _a.toString()) || `step-${index}`,
            stepNumber,
            instruction,
            method: step.method,
            timer: step.timer,
            timerLabel: step.timerLabel,
            hasImage: step.hasImage || false,
            imageUrl: step.imageUrl,
            severity: apiStep.severity || 'info',
            mode_key: apiStep.mode_key || 'hands_on',
            duration_min: apiStep.duration_min || 0,
            warning: apiStep.warning,
            equipment: apiStep.equipment || [],
            ingredients_used: apiStep.ingredients_used || [],
        };
    });
}
